import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IOrderDetail} from '@mysas/shared/data-access-orders';
import {environment} from '@mysas/shared/util-environment';
import {OfferingState} from "@mysas/portal/orders/data-access-orders";

@Component({
  selector: 'mysas-order-basic-info',
  templateUrl: './order-basic-info.component.html',
  styleUrls: ['./order-basic-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderBasicInfoComponent implements OnInit {
  @Input() order: Partial<IOrderDetail> | undefined;
  @Input() offeringList: OfferingState[] | undefined;
  createCaseLink = environment.links['csmCreateCase'].url;
  anyExpandable: boolean = false;

  @Output() toggleOfferingExpansionClicked = new EventEmitter<number>();

  ngOnInit() {
    this.anyExpandable = !!this.offeringList && this.offeringList.some(x => x.components.length > 0)
  }

  expandOrCollapse(index: number) {
    this.toggleOfferingExpansionClicked.emit(index);
  }
}
